import * as React from "react";
import type { SVGProps } from "react";
const SvgLoader02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.35 5.7V2.1m0 19.8v-4.8m5.7-5.7h2.1m-18.3 0h4.8m9.73-4.03 1.67-1.67M5.926 18.825l3.394-3.394m8.062 0 1.669 1.668M5.925 3.975 9.319 7.37"
    />
  </svg>
);
export default SvgLoader02;
